import React, { useState, useEffect, useCallback, useRef } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import {
  Icon,
  Divider,
  Dropdown,
  Button,
  Loader,
  Modal,
} from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  DivCurso,
  Input,
  Div,
  DivIcon,
  DivConteudo,
  Label,
  DivTitulo,
  Select,
  CreateButton,
} from "./styled";
import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../../services/auth";
import cleanTitle from "../../../../../utils/cleanTitle";

const CombosPlataformaEditar = (props) => {
  const id = props.match.params.id;
  const [nomeCombo, setNomeCombo] = useState("");
  const [newCombo, setNewCombo] = useState([]);
  const [combo, setCombo] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCursos, setSelectedCursos] = useState([]);
  const validadeCombo = useRef([]);
  const [optionsCurso, setOptionsCurso] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedCursos([]);
    setModalOpen(false);
  };

  const handleMultipleCursosChange = useCallback((e, { value }) => {
    setSelectedCursos(value);
  }, []);

  const handleSaveFromModal = () => {
    if (selectedCursos.length === 0) {
      swal("Atenção", "Selecione pelo menos um curso para adicionar", "warning");
      return;
    }

    const cursosToAdd = selectedCursos
      .map(cursoId => {
        const course = optionsCurso.find(option => option.value === cursoId);
        
        if (!course) return null;

        const existingCombo = combo.find(curso => curso.id === cursoId);
        if (existingCombo) {
          return null;
        }

        return {
          id: cursoId,
          titulo: course.text,
          validade: '1825',
          datas_liberacao: '0',
          url_amigavel: course.url,
        };
      })
      .filter(curso => curso !== null);

    if (cursosToAdd.length === 0) {
      swal("Atenção", "Todos os cursos selecionados já estão no combo", "warning");
      return;
    }

    if (cursosToAdd.length < selectedCursos.length) {
      const duplicados = selectedCursos.length - cursosToAdd.length;
      swal(
        "Atenção", 
        `${duplicados} curso(s) já estava(m) no combo e não foi(ram) adicionado(s)`,
        "info"
      );
    }

    setCombo([...combo, ...cursosToAdd]);
    setSelectedCursos([]);
    setModalOpen(false);
  };

  const loadCombo = useCallback(async () => {
    try {
      const res = await api.get(`/admin/combos/full/${id}`);

      const { combo: fullCombo } = res.data;

      const { cursoCombo, cursos } = fullCombo;

      setNomeCombo(cursoCombo.titulo);
      setCombo(cursos);
      setLoading(false);
    } catch (err) {
      swal("Erro !", "Combo inexistente !", "error");
    }
  }, [id]);

  useEffect(() => {
    loadCursos();
    loadCombo();
  }, [loadCombo]);

  const loadCursos = async () => {
    await api
      .get("/cursos-ids")
      .then((res) => {
        const newOptions = res.data.map((cur) => ({
          key: cur.id,
          text: `${cur.curso} [${cur.id}]`,
          value: cur.id,
          url: cur.url_amigavel
        }));
        setOptionsCurso(newOptions);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const deleteCurso = useCallback(
    (id) => {
      const newCombo = combo.filter((curso) => curso.id !== id);
      setCombo(newCombo);
    },
    [combo]
  );

  const handleSubmit = async () => {
    const newCursos = combo.map((curso) => curso.id).join(",");

    const payload = {
      cursos: newCursos,
      validades: combo.map(_ => '1825').join(','),
      datas_liberacao: combo.map(_ => '0').join(','),
      id_demonstracao: null,
    };

    await api
      .put(`/admin/combo/${id}`, payload)
      .then(async (res) => {
        let logs = { local: "ead/combos", texto: `editou o combo de id=${id}` };
        await api.post("system_logs", { acao: JSON.stringify(logs) });
        swal("Sucesso!", "Edição de combo bem sucedida", "success").then(
          (res) => {
            // window.location.href = "/admin/ead/combos";
          }
        );
      })
      .catch((err) => {
        console.error(err);
        swal(
          "Erro ao criar o combo",
          "Por favor, insira preencha todos os campos necessários",
          "error"
        );
      });
  };

  const handleChangePosition = (index, newIndex) => {
    const newCombo = [...combo];

    const aux = newCombo[index];
    newCombo[index] = newCombo[newIndex];
    newCombo[newIndex] = aux;

    setCombo(newCombo);
  };

  return (
    <>
      <Container>
        <AdminMenu />
        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>
              Editar COMBO{" "}
              <CreateButton onClick={handleOpenModal}>Adicionar</CreateButton>
            </Title>

            <DivTitulo>
              <h2>{nomeCombo}</h2>
            </DivTitulo>
            <div
              style={{
                display: "flex",
                gap: "20px",
                justifyContent: "flex-start",
                flexWrap: "wrap",
                marginBottom: "20px",
              }}
            >
              {combo.map((curso, index) => (
                <div
                  key={curso.id}
                  style={{
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    width: "250px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: "0.5rem",
                    }}
                  >
                    <button
                      title="Ordenar para esquerda"
                      style={{
                        visibility: index > 0 ? "visible" : "hidden",
                        cursor: "pointer",
                      }}
                      onClick={() => handleChangePosition(index, index - 1)}
                    >
                      <Icon name="chevron left" />
                    </button>
                    <button
                      title="Ordenar para direita"
                      style={{
                        visibility:
                          index < combo.length - 1
                            ? "visible"
                            : "hidden",
                        cursor: "pointer",
                      }}
                      onClick={() => handleChangePosition(index, index + 1)}
                    >
                      <Icon name="chevron right" />
                    </button>
                  </div>
                  <div
                    style={{
                      position: "relative",
                      marginBottom: "10px",
                    }}
                  >
                    <img
                      src={`https://files.voitto.com.br/cursos/small/${curso.url_amigavel}.jpg`}
                      alt={"Capa do Curso"}
                      style={{
                        width: "100%",
                        height: "auto",
                        objectFit: "cover",
                        borderRadius: "5px",
                        display: "block",
                      }}
                    />
                    <Icon
                      link
                      name="remove"
                      color="red"
                      size="large"
                      onClick={() => deleteCurso(curso.id)}
                      style={{
                        position: "absolute",
                        top: "4px",
                        right: "4px",
                        backgroundColor: "white",
                        borderRadius: "99999px",
                        padding: "2px",
                        cursor: "pointer",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      textAlign: "center",
                      fontSize: "14px",
                      fontWeight: "bold",
                      lineHeight: "1.2",
                      maxWidth: "220px",
                      minHeight: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {cleanTitle(curso.titulo)}
                  </div>
                </div>
              ))}
            </div>

            <Divider inverted />
            <Button onClick={handleSubmit}>
              <Icon name="save" />
              Salvar
            </Button>
          </Content>
        )}
        <Modal open={modalOpen} onClose={handleCloseModal} closeIcon>
          <Modal.Header>Adicionar Cursos ao Combo</Modal.Header>
          <Modal.Content>
            <DivCurso>
              <Div>
                <Label>Nome/Id dos cursos</Label>
                <Dropdown
                  placeholder="Selecione um ou mais cursos"
                  fluid
                  search
                  selection
                  multiple
                  options={optionsCurso}
                  value={selectedCursos}
                  onChange={handleMultipleCursosChange}
                />
              </Div>
            </DivCurso>
            <div style={{ marginTop: "1rem", fontSize: "12px", color: "#666" }}>
              <Icon name="info circle" />
              Você pode selecionar múltiplos cursos de uma vez
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button color="grey" onClick={handleCloseModal}>
              Cancelar
            </Button>
            <Button color="green" onClick={handleSaveFromModal}>
              <Icon name="plus" />
              Adicionar {selectedCursos.length > 0 && `(${selectedCursos.length})`}
            </Button>
          </Modal.Actions>
        </Modal>
      </Container>
    </>
  );
};

export default withRouter(CombosPlataformaEditar);